import { sendGTMEvent } from '@/modules/common/services/sendGTMEvent';
import { DATA_LAYER_EVENTS } from '@/modules/product/services/data-layer-events/events';

// Define AppliedFilter type
type AppliedFilter = {
  type: string;
  value: string;
};

type ViewSearchResultsDataLayerEventProps = {
  query_id: string;
  search_term: string; // The actual term searched
  method: string; // Suggestion, History, Pure search, Trending
  results: number; //number of results returned
  filtered: boolean; // Yes if any filters are in place at time of search, no need to indicate which fitlers were used - can be achieved in future state. Pass No if no filters in use at time of search
  applied_filters?: AppliedFilter[]; // Add applied_filters prop
  searchTestId?: number; // Optional search test ID
  searchTestVariantId?: number; // Optional search test variant ID
};

export function viewSearchResultsDataLayerEvent({
  query_id,
  search_term,
  method,
  filtered,
  results,
  applied_filters, // Destructure applied_filters
  searchTestId,
  searchTestVariantId,
}: ViewSearchResultsDataLayerEventProps) {
  sendGTMEvent({ eventData: null });
  sendGTMEvent({
    event: DATA_LAYER_EVENTS.view_search_results,
    eventData: {
      query_id,
      search_term,
      method,
      filtered,
      results,
      ...(searchTestId && { searchTestId }),
      ...(searchTestVariantId && { searchTestVariantId }),
      ...(applied_filters?.length && { applied_filters }), // Conditionally add applied_filters
    },
  });
}
